exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.attachPresentSecond .rightText[data-v-17dce000] {\n  position: absolute;\n  right: 0.75rem;\n  top: 0.75rem;\n  font-family: PingFangSC-Regular;\n  font-size: 0.6rem;\n  color: #555555;\n}\n.attachPresentSecond .protocol[data-v-17dce000] {\n  letter-spacing: 0.025rem;\n  text-align: justify;\n  padding: 0 0.75rem;\n}", ""]);

// exports
